import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import './../styles/Header.css';
import PageTitle from '../components/PageTitle';
import LoginButton from '../components/LoginButton';
import SignupButton from '../components/SignupButton';
import ProfileMenu from '../components/ProfileMenu';
import GoogleTranslate from './GoogleTranslateBox';
// import { LanguageSelector } from "react-custom-google-translate";

// Main navbar on website
const Header = () => {
  const location = useLocation();
  const { isLoggedIn } = useContext(AuthContext);
  const isLoginPage = location.pathname === '/login';
  const isSignupPage = location.pathname === '/signup';

  const logoStyle = {
      position: 'absolute',
      display: 'flex',
      left: '0',
      height: '100%',
      top: '0px',
  };

  return (
    <div className="header">

      {/* <Link to="/"> */}
      <Link to="/" className="header-title">
        {/* <PageTitle /> */}
        <img src="/FRCLogo.png" alt="Family Resource Center Logo" style={logoStyle} />
      </Link>


      <div className="header-buttons">
        <GoogleTranslate/>
        {/* <LanguageSelector /> */}
        {!isLoggedIn && !isLoginPage && <LoginButton />}
        {!isLoggedIn && !isSignupPage && <SignupButton />}
        {isLoggedIn && <ProfileMenu />}
      </div>
    </div>
  );
};

export default Header;
